import React, { useCallback } from 'react';
import styled, { css } from 'styled-components';
import { useMappedState } from 'redux-react-hook';
import _map from 'lodash/map';
import _size from 'lodash/size';
import { PrimaryButton } from 'styles/elements/buttons/primaryCare';
import { Spinner } from 'styles/blocks/spinner';
import { STRINGS } from 'config';
import { fadeOut, fadeInAndOut } from 'styles/animations';

const { PRODUCT: { PRIMARY_CARE, E_SPECIALIST } } = STRINGS;

export const Button = styled(PrimaryButton)`
  position: relative;
  ${props => (props.theme.buttonPrimaryBorderRadius ? `border-radius: ${props.theme.buttonPrimaryBorderRadius}` : '')};
  ${props => (props.isDisabled ? `
    background: ${props.theme.buttonPrimaryDisabledBackground};
    color: ${props.theme.disabledFontColor};
    border: ${props.theme.buttonPrimaryDisabledBorder};
    box-shadow: ${props.theme.buttonPrimaryDisabledBoxShadow};

    :focus {
      box-shadow: 0 0px 1px 2px white, 0 0px 4px 4px #86858f;
    }
  ` : '')};
  ${props => (props.theme.additionalNextButtonStyles ? props.theme.additionalNextButtonStyles : '')};
`;

const spinnerStyles = css`
  position: absolute;
  right: 20px;
  top: 16px;
`;

const DELAY = 0.86;
const DURATION = 10;

const Span = styled.span`
  opacity: 0;
  position: absolute;
  width: 100%;
  left: 0;
  top:15px;
  animation: ${fadeInAndOut} ${DURATION}s linear infinite;
  animation-delay: ${props => (DELAY + (props.delay * (DURATION / props.count)))}s
`;

const RegularButtonText = styled.p`
  margin: 0;
  ${props => (props.loadingText && props.isLoading ? css`
    animation: ${fadeOut} 2s ${DELAY}s;
    animation-fill-mode: forwards;
  ` : '')};
`;

export function NextButton({ isDisabled, onClick, loadingText, children, dataAutomation }) {
  const mapState = useCallback(state => ({
    isLoading: state.consultationReducer.isLoading,
    isForwardNavigation: state.consultationReducer.isForwardNavigation,
    product: state.consultationReducer.product,
  }), []);
  const { isLoading, isForwardNavigation, product } = useMappedState(mapState);
  const primaryCareOrESpecialist = product === PRIMARY_CARE || product === E_SPECIALIST;
  return (
    <Button
      onClick={() => (isDisabled ? null : onClick())}
      isDisabled={isDisabled}
      aria-disabled={isDisabled}
      data-automation={dataAutomation}
    >
      <RegularButtonText isLoading={isLoading} loadingText={!!loadingText}>{children || (primaryCareOrESpecialist ? 'Next step' : 'Next')}</RegularButtonText>
      {isLoading && _map(loadingText, (text, index) => <Span key={`custom-loading-text-${index}`} delay={index} count={_size(loadingText)}>{text}</Span>)}
      {primaryCareOrESpecialist && <Spinner isVisible={isLoading && isForwardNavigation} spinnerStyles={spinnerStyles} />}
    </Button>
  );
}
